import { TERMS_AND_CONDITIONS } from "../utils/termsAndConditions";
import { romanize } from "../utils/helpers";
import { useState } from "react";
import { PrimaryButton } from "../components/Buttons";
import { useAlert, useApi } from "../hooks";
import { useNavigate } from "react-router-dom";
import { CheckboxInput } from "../components/Inputs";
import constants from "../utils/constants";
import { useUserStore } from "../context";

export const Section = ({ romanNumeral, header, paragraph }) => {
  const paragraphWithLineBreaks = paragraph.replace(/\n/g, '<br/>');

  return(
    <div className="my-8">
      <h6 className="text-xl font-semibold">{romanNumeral}. {header}</h6>
      <p className="mt-4" dangerouslySetInnerHTML={{ __html: paragraphWithLineBreaks }}></p>

    </div>
  )
}

export default function TermsAndConditions({canAccept}) {
  const summaryWithLineBreaks = TERMS_AND_CONDITIONS.summary.replace(/\n/g, '<br/>');
  return(
    <div className="p-4">
      <h2 className="text-3xl font-semibold">Terms &amp; Conditions</h2>
      <p className="mt-4" dangerouslySetInnerHTML={{ __html: summaryWithLineBreaks }}></p>

      {TERMS_AND_CONDITIONS.sections.map((x, i) => {
        return(
          <Section romanNumeral={romanize(i + 1)} header={x.header} paragraph={x.paragraph}/>
        )
      })}
      {!!canAccept && (
        <AcceptTerms
          endpoint={"user/AcceptTermsAndConditions"}
          checkboxText={`I accept ${constants.APP_NAME}'s Terms & Conditions`}
          successMessage={"Terms and conditions accepted"}
          errorMessage={"Unable to accept terms and conditions"}
        />
      )}
    </div>
  )
}

export function AcceptTerms({endpoint, checkboxText, successMessage, errorMessage}) {
  const navigate = useNavigate();
  const alert = useAlert();
  const { post } = useApi();
  const { setCurrentUser  } = useUserStore();
  const [acceptedTermAndConditions, setAcceptedTermAndConditions] = useState(false);
  const [saving, setSaving] = useState(false);
  function submit() {
    if (saving) return;
    setSaving(true);
    post(endpoint)
    .then(res => {
      setCurrentUser(res);
      alert(successMessage, "", "success");
      navigate("/");
    })
    .catch(err => {
      alert("Server error", errorMessage, "error");
    })
    .finally(() => {
      setSaving(false);
    });
  }
  return (
    <div className="flex flex-col gap-y-4 mt-4">
      <CheckboxInput
          textSize="text-sm"
          label={
              <div>
                  {checkboxText}
              </div>
          }
          name="t&c"
          value={acceptedTermAndConditions ? "checked" : "unchecked"}
          onChange={() => {
              setAcceptedTermAndConditions(!acceptedTermAndConditions)
          }}
      />
      <div className="w-full md:w-1/6">
        <PrimaryButton
          text={"SUBMIT"}
          disabled={!acceptedTermAndConditions}
          onClick={submit}
        />
      </div>
    </div>
  )
}